var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center justify-center h-full"},[_c('div',{staticClass:"relative flex flex-grow items-center justify-between h-full bg-bg",class:{
      'items-stretch my-6 w-mobile-container max-h-mobile-container rounded-2.25xl border-2 bg-bg border-bg overflow-hidden':
        !_vm.isMobile,
      'flex-col w-full': _vm.isMobile,
    },attrs:{"id":"pageWrapper"}},[_vm._t("logo"),_c('div',{staticClass:"z-10 flex flex-col w-full bg-white overflow-y-auto",class:{
        'flex-grow absolute h-screen': _vm.isFullscreenDropdown && _vm.isMobile,
        'rounded-2xl relative': !_vm.isMobile,
        'min-h-mobile-content': _vm.isMobile,
        'rounded-t-2xl': _vm.isMobile && !_vm.isFullscreenDropdown,
      },attrs:{"id":"contentContainer"}},[_c('div',{staticClass:"form-wrapper",class:{ static: _vm.isMobile }},[_vm._t("form"),_vm._t("footer")],2)])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }